"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserScope = void 0;
/**
 * Scope that is sent as an axway header "channel".
 * the value employee is for example sent if you have an agent scope and an employee_id in your token.
 */
var UserScope;
(function (UserScope) {
    /** Value for the employee scope (so for example, you have the agent scope and an employeeId) */
    UserScope["EMPLOYEE"] = "employee";
    /** Value for the customer scope (you have a customer internal scope and an accountId) */
    UserScope["CUSTOMER"] = "customer";
    UserScope["SALES_PARTNER"] = "salespartner";
    UserScope["DIRECT_SALES_PARTNER"] = "directsalespartner";
    UserScope["UNKNOWN"] = "unknown";
})(UserScope = exports.UserScope || (exports.UserScope = {}));
